import script from "./ClearmentHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./ClearmentHeader.vue?vue&type=script&setup=true&lang=js"

import "./ClearmentHeader.vue?vue&type=style&index=0&id=28ec64b0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28ec64b0"]])

export default __exports__